module.exports = {
      id: "visibility-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#visibility",
      toString: function () {
        return this.url;
      }
    }